import {IApiModel} from 'app/original-models/api-model.interface';

export class Bank implements IApiModel<Bank> {
    name?: string;
    // icon: string;
    code: number;
    loginHint?: string;
    loginFieldPin?: string;
    loginFieldUserId?: string;
    loginFieldCustomerId?: string;
    blz?: string;
    bic?: string;
    location?: string;

    // credentials: any[];

    getApiModel(): any {
        return undefined;
    }

    setFromApiModel(apiModel: any): this {
        this.name = apiModel.name;
        this.code = apiModel.id;
        this.loginHint = apiModel.loginHint;
        this.loginFieldPin = apiModel.loginFieldPin;
        this.loginFieldUserId = apiModel.loginFieldUserId;
        this.loginFieldCustomerId = apiModel.loginFieldCustomerId;
        this.blz = apiModel.blz;
        this.bic = apiModel.bic;
        switch (apiModel.location ? apiModel.location.toLowerCase() : '') {
            case 'de':
                this.location = 'Germany';
                break;
            case 'at':
                this.location = 'Austria';
                break;
            default:
                this.location = 'other';
                break;
        }
        return this;
    }
}
